import { UbicacionParamsDTO } from '@/application/dto/ubicaciones/UbicacionParamsDTO';
import { Ubicacion } from '@/domain/entities/ubicacion';
import { IUbicacionRepository } from '@/domain/repositories/IUbicacionRepository';

export class GetUbicacionesUseCase {
  constructor(
    private readonly repository: IUbicacionRepository
  ) {}

  async execute(params?: UbicacionParamsDTO): Promise<Ubicacion[]> {
    return this.repository.findAll(params);
  }
}
